import LumaResourceWorkspace, {lumaMoney} from '../../../components/admin/LumaResourceWorkspace';
import React, { useEffect, useState } from 'react';
import { fetchClientesRetorno, ClienteRetorno } from '../../../services/citasService';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { User, Calendar, Clock, BarChart2, ArrowRight, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';

const formatoFechaEspanol = (fechaStr: string | null | undefined): string => {
    if (!fechaStr) return '-';
    const fechaLocalStr = fechaStr.includes('T') ? fechaStr : `${fechaStr}T00:00:00`;
    const fecha = new Date(fechaLocalStr);
    if (isNaN(fecha.getTime())) return fechaStr;
    return format(fecha, "d 'de' MMMM, yyyy", { locale: es });
};

const RetornoClientesPage = () => {
    const [clientesRetorno, setClientesRetorno] = useState<ClienteRetorno[]>([]);
    const [loadingClientes, setLoadingClientes] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const loadClientesRetorno = async () => {
            setLoadingClientes(true);
            try {
                const clientes = await fetchClientesRetorno();
                const clientesOrdenados = clientes.sort((a, b) => b.cliente_id - a.cliente_id);
                setClientesRetorno(clientesOrdenados);
            } catch (error) {
                /* Browser diagnostics omitted. */
            } finally {
                setLoadingClientes(false);
            }
        };
        loadClientesRetorno();
    }, []);

    // Filtrar clientes por nombre
    const filteredClientes = clientesRetorno.filter(cliente =>
        cliente.cliente_nombre.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return <><LumaResourceWorkspace title="Dashboard Score" description="Consulta y gestiona la información de tu coworking." group="Dashboard" rows={clientesRetorno} columns={[{key:'cliente_nombre',label:'Cliente'},{key:'cantidad_citas',label:'Visitas'},{key:'frecuencia_promedio_dias',label:'Frecuencia (días)'},{key:'categoria_retorno',label:'Categoría'},{key:'prox_cita_estimada',label:'Próxima visita',render:r=>formatoFechaEspanol(r.prox_cita_estimada)}]} idKey="cliente_id" nameKey="cliente_nombre" statusKey="estado" canRead={true} onCreate={undefined} onEdit={undefined} onDelete={undefined} extraActions={r=><><Link to={`/kardex-citas/detalle/${r.cliente_id}`}>Ver kardex ↗</Link></>}></LumaResourceWorkspace></>;
};

export default RetornoClientesPage;
